var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigcommerce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#34313f",
    d: "M24.557,26.203h4.917c1.398,0,2.284-0.77,2.284-2.006c0-1.166-0.886-2.006-2.284-2.006h-4.917 c-0.163,0-0.303,0.14-0.303,0.28v3.453C24.277,26.086,24.394,26.203,24.557,26.203z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#34313f",
    d: "M24.557,34.158h5.08c1.561,0,2.494-0.793,2.494-2.193c0-1.213-0.886-2.193-2.494-2.193h-5.08 c-0.163,0-0.303,0.14-0.303,0.28v3.803C24.277,34.041,24.394,34.158,24.557,34.158z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#34313f",
    d: "M42.548,4.086L28.006,18.597h2.377c3.705,0,5.896,2.333,5.896,4.876 c0,2.006-1.352,3.476-2.796,4.129c-0.233,0.093-0.233,0.42,0.023,0.513c1.678,0.653,2.866,2.403,2.866,4.456 c0,2.893-1.934,5.202-5.686,5.202h-10.3c-0.163,0-0.303-0.14-0.303-0.28V26.506L4.119,42.417C3.91,42.627,4.049,43,4.352,43h38.382 c0.14,0,0.256-0.117,0.256-0.257V4.296C43.06,4.04,42.734,3.9,42.548,4.086z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigcommerce);
export default __webpack_public_path__ + "static/media/bigcommerce.58e262c53d5fea4e35b575df0ad9b945.svg";
export { ForwardRef as ReactComponent };